// component
import Iconify from '../../components/Iconify'

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />

const investorAdminSidebarConfig = [
  {
    title: 'داشبورد',
    path: '/investor/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill'),
    key: 'DASHBOARD',
  },
  {
    title: 'تایید سرمایه‌گذاران',
    path: '/investor/dashboard/investor-verification/list',
    icon: getIcon('fluent:people-money-20-filled'),
    key: 'INVESTOR_VERIFICATION',
  },
  {
    title: 'درخواست‌های سرمایه‌گذاری',
    path: '/investor/dashboard/investing-requests/start-up/list',
    icon: getIcon('fluent:money-hand-24-filled'),
    key: 'INVESTING_REQUESTS',
  },
  {
    title: 'مدیریت سرمایه‌گذاران',
    path: '/investor/dashboard/manage-investor/list',
    icon: getIcon('ant-design:pie-chart-filled'),
    key: 'INCREASE_CREDIT',
  },
  {
    title: 'تیکت پشتیبانی',
    path: '/investor/dashboard/ticket/list',
    icon: getIcon('ant-design:message-filled'),
    key: 'TICKET',
  },
  {
    title: 'تنظیمات',
    path: '/investor/dashboard/setting',
    icon: getIcon('ant-design:setting-filled'),
    key: 'SETTING',
  },
]

export default investorAdminSidebarConfig
